import axios from "axios";
import i18n from "@/i18n/i18n";
import url from "@/rest/url"

let resetCacheHttpClient = axios.create();
resetCacheHttpClient.defaults.timeout = 1000 * 60 * 60; //1 hour

let httpClient = axios.create();

const pdm = {
    async resetCache(url) {
        const options = headers.getSimpleGetHeader();
        return await resetCacheHttpClient.get(url, options);
    },
    async overviewByKonfigModel(csrfToken, konfigModel) {
        const options = headers.getPostJsonGetJsonCsrfHeader(csrfToken);
        return await httpClient.post(url.overviewByKonfigModelURL, konfigModel, options);
    },
}

const headers = {
    getSimpleGetHeader() {
        return {
            headers: {
                'Accept-Language': i18n.locale
            }
        }
    },
    getPostJsonGetJsonCsrfHeader(csrfToken) {
        return {
            headers: {
                'Accept-Language': i18n.locale,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': csrfToken['X-CSRF-TOKEN']
            }
        }
    }
}

export default pdm;
